import { defineComponent as _defineComponent } from 'vue'
import { Spacing } from '../../../../helpers/shared-props';
import {
  AbSection,
  AbSlider,
  AbSliderItem,
  AbTitle,
  AbDescription,
  AbButton,
  AbContainer,
} from '../../../ui';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { CdnImg } from '@webplatform/cdn-image';
import { computed, ref } from 'vue-demi';

interface Props {
  id?: string | null;
  items: {
    textColor?: 'light' | 'dark' | null;
    images?: {
      mobile: {
        src: string;
        alt?: string | null;
      };
      desktop: {
        src: string;
        alt?: string | null;
      };
    } | null;
    title?: string | null;
    description?: string | null;
    button?: {
      link?: string | null;
      text: string;
    } | null;
  }[];
  spacing?: Spacing | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionBannersSlider',
  props: {
    id: null,
    items: null,
    spacing: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string | null;
  items: {
    textColor?: 'light' | 'dark' | null;
    images?: {
      mobile: {
        src: string;
        alt?: string | null;
      };
      desktop: {
        src: string;
        alt?: string | null;
      };
    } | null;
    title?: string | null;
    description?: string | null;
    button?: {
      link?: string | null;
      text: string;
    } | null;
  }[];
  spacing?: Spacing | null;
};



const swiperContainerRef = ref();
const swiperActiveSlideIndex = ref(0);
const progress = ref('0%');
const isNeedPagination = computed(() => props.items.length > 1);

const sliderOptions: SwiperOptions = {
  loop: true,
  pagination: {
    enabled: true,
    clickable: true,
    el: '.feature-banners-slider-section__pagination',
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  navigation: true,
  on: {
    activeIndexChange: (swiper) => {
      swiperActiveSlideIndex.value = swiper.realIndex;
    },
    autoplayTimeLeft: (_: any, __: any, percentage: number) => {
      progress.value = `${100 - percentage * 100}%`;
    },
  },
};

return { __sfc: true,props, swiperContainerRef, swiperActiveSlideIndex, progress, isNeedPagination, sliderOptions, AbSection, AbSlider, AbSliderItem, AbTitle, AbDescription, AbButton, AbContainer, CdnImg }
}

})